import React, { useEffect, useState } from "react";

import "./../styles/styles.css";
import { SharpButtons } from "./SharpButtons";
import { Handler } from "../common/handler";
import { PlayButton } from "./PlayButton";
import SaveDialog from "./SaveDialog";
import DeleteDialog from "./DeleteDialog";
import wx from "weixin-js-sdk";
import { getUrlParam } from "../utils/helpers";
import FullNote from "../assets/icons/full-note.svg"
import FullNoteActive from "../assets/icons/full-note-active.svg"
import HalfNote from "../assets/icons/half-note.svg"
import HalfNoteActive from "../assets/icons/half-note-active.svg"
import QuarterNote from "../assets/icons/quarter-note.svg"
import QuarterNoteActive from "../assets/icons/quarter-note-active.svg"
import TrashNote from "../assets/icons/trash.svg"
import ChordNote from "../assets/icons/chord.svg"
import ShareNote from "../assets/icons/share.svg"
import SaveIcon from "../assets/icons/save.svg"

const noteIcons = {
  full: {
    normal: FullNote,
    active: FullNoteActive,
  },
  half: {
    normal: HalfNote,
    active: HalfNoteActive,
  },
  quarter: {
    normal: QuarterNote,
    active: QuarterNoteActive,
  },
};

interface TopNavBarProps {
  title: string;
  pickNote: (note: string | null) => void;
  cleanAll: () => void;
  handler: Handler | null;
  showChordPopup: () => void;
}

function TopNavBar({
  title,
  pickNote,
  cleanAll,
  handler,
  showChordPopup,
}: TopNavBarProps) {
  const [activeNote, setActiveNote] = useState<string | null>("quarter");

  const [showSaveDialog, setShowSaveDialog] = useState<boolean>(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);

  useEffect(() => {
    pickNote(activeNote);
  }, []);

  useEffect(() => {
    pickNote(activeNote);
  }, [activeNote]);

  const selectNote = (note: String | null) => {
    if (note === activeNote) {
      setActiveNote(null);
      return;
    }

    switch (note) {
      case "full":
        setActiveNote("full");
        break;
      case "half":
        setActiveNote("half");
        break;
      case "quarter":
        setActiveNote("quarter");
        break;
      default:
        setActiveNote(null);
    }
  };

  const NoteButton = ({
    noteIcon,
    name,
    isActive = false,
    callback = () => {},
  }: {
    noteIcon: { active: any; normal: any };
    name: string;
    isActive: boolean;
    callback: () => void;
  }) => {
    return (
      <button
        className="note"
        onClick={() => {
          selectNote(name);
          callback();
        }}
      >
        <img
          src={isActive ? noteIcon.active : noteIcon.normal}
          width={30}
          height={30}
          alt=""
        />
      </button>
    );
  };

  const TrashButton = () => {
    return (
      <button
        className="right-button"
        onClick={() => {
          setShowDeleteDialog(true);
          // cleanAll();
        }}
      >
        <img src={TrashNote} />
      </button>
    );
  };

  const ChordButton = () => {
    return (
      <button className="right-button" onClick={showChordPopup}>
        <img src={ChordNote} />
      </button>
    );
  };

  const ShareButton = () => {
    const shareStave = () => {
      // console.log('dddd share', wx.miniProgram);
      const id = getUrlParam('id');

      if (id == null) {
        alert('请先保存乐谱!');
        return;
      }

      wx.miniProgram.navigateTo({url: `/pages/share/share?id=${id}&title=${title}`});
    };
    return (
      <button open-type="share" className="right-button" onClick={shareStave}>
        <img src={ShareNote} />
      </button>
    );
  };

  const SaveButton = () => {
    return (
      <button
        className="right-button"
        onClick={() => {
          setShowSaveDialog(true);
        }}
      >
        <img width={30} height={30} src={SaveIcon} />
      </button>
    );
  };
  return (
    <div className="top-nav-bar">
      <div className="left-buttons">
        {/*<button type="button">*/}
        {/*  <img*/}
        {/*    src={require("../assets/icons/arrow-left-line.png")}*/}
        {/*    alt="arrow-left-line"*/}
        {/*  />*/}
        {/*</button>*/}
        <h3 className="new-title">{title}</h3>
        <PlayButton handler={handler} />
      </div>
      <div className="center-buttons">
        <NoteButton
          noteIcon={noteIcons.full}
          name="full"
          isActive={activeNote === "full"}
          callback={() => {
            setActiveNote("full");
          }}
        />
        <NoteButton
          noteIcon={noteIcons.half}
          isActive={activeNote === "half"}
          name="half"
          callback={() => {
            setActiveNote("half");
          }}
        />
        <NoteButton
          noteIcon={noteIcons.quarter}
          name="quarter"
          isActive={activeNote === "quarter"}
          callback={() => {
            setActiveNote("quarter");
          }}
        />

        {/*<span style={{ width: 10, margin: 10 }}></span>*/}
        {/*<SharpButtons handler={handler} />*/}
      </div>
      <div className="right-buttons">
        <TrashButton />
        <ChordButton />
        <ShareButton />
        <SaveButton />
      </div>
      <SaveDialog
        show={showSaveDialog}
        close={() => setShowSaveDialog(false)}
        handler={handler}
        title={title}
      ></SaveDialog>
      <DeleteDialog
        show={showDeleteDialog}
        close={() => setShowDeleteDialog(false)}
        clearStaves={cleanAll}
      ></DeleteDialog>
    </div>
  );
}

export default TopNavBar;
